import { render, staticRenderFns } from "./menuAlcance.vue?vue&type=template&id=a061c6a2"
import script from "./menuAlcance.vue?vue&type=script&lang=js"
export * from "./menuAlcance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports